import { notifyError } from 'helpers/errorNotifier';
import useIsPartner from 'hooks/useIsPartner';
import { useEffect } from 'react';
import { isFeatureEnabled, publicEnvConfig } from 'helpers/env';

function useIntercomBoot(showIntercom = true) {
	const isStockwavePartner = useIsPartner('stockwave');
	useEffect(() => {
		try {
			if (!isFeatureEnabled(publicEnvConfig.INTERCOM_ENABLED)) return;

			if (showIntercom && !isStockwavePartner) {
				window.Intercom('boot', {
					app_id: publicEnvConfig.INTERCOM_APP_ID,
				});
			}
		} catch (error) {
			notifyError('Intercom error - boot');
		}
	});
}

export default useIntercomBoot;
